<template>
  <div>
    <slick
      v-if="productResults"
      ref="slick"
      :options="slickOptions"
      class="products"
    >
      <product-card
        :product="product"
        :size="size"
        :bucket="bucket"
        :options="options"
        :position="index + 1"
        :productLinkDestination="productLinkDestination"
        :listname="listname"
        :reco="reco"
        :collection="true"
        :hidePreferences="hidePreferences"
        v-for="(product, index) in productResults"
        v-bind:key="index"
      ></product-card>
    </slick>
  </div>
</template>

<script>
import ProductCard from "./ProductCard";
import Slick from "vue-slick";

export default {
  name: "ProductCollectionHorizontal",
  props: {
    listname: {
      type: String,
      default: ""
    },
    reco: {
      type: String,
      default: "default"
    },
    products: {
      type: Array
    },
    productsToShowMedium: {
      type: Number,
      default: 3
    },
    productsToShowLarge: {
      type: Number,
      default: 4
    },
    bucket: {
      type: String,
      default: "cart" // cart or orderAddOns
    },
    size: {
      type: String,
      default: "normal" // normal or small
    },
    productLinkDestination: {
      type: String,
      default: "link" // link, modal. A switch that choose how to handle the destination of clicking on a link in the product card
    },
    options: {
      type: Object,
      default: () => ({
        showCoupons: true,
        showAddToList: true
      })
    },
    hidePreferences: {
      type: Boolean,    // Whether to hide the preference component on the product card.
      default: false   // Currently set to true for some instances where there are display issues with the preference popover.
    },
  },
  components: {
    "product-card": ProductCard,
    Slick
  },
  data() {
    return {};
  },
  computed: {
    slickOptions() {
      return {
        infinite: false,
        variableWidth: true,
        mobileFirst: true,
        adaptiveHeight: true,
        prevArrow:
          '<div class="fa fa-angle-left hup-slider__nav product-collection__nav hup-slider__nav--prev"></span>',
        nextArrow:
          '<div class="fa fa-angle-right hup-slider__nav product-collection__nav hup-slider__nav--next"></span>',

        slidesToScroll: 1,
        slidesToShow: 2, // adaptiveHeight does not work if this is set to 1
        arrows: false,

        respondTo: "slider",
        responsive: [
          {
            breakpoint: 576, //3*192px
            settings: {
              arrows: true,
              slidesToScroll: 1,
              slidesToShow: this.productsToShowMedium
            }
          },
          {
            breakpoint: 768, //4*192px
            settings: {
              arrows: true,
              slidesToScroll: 1,
              slidesToShow: this.productsToShowLarge
            }
          }
        ]
      };
    },
    productResults() {
      return this.products;
    }
  },
  methods: {
    next() {
      this.$refs.slick.next();
    },
    prev() {
      this.$refs.slick.prev();
    },

    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.products {
  margin: -4px;
}
</style>

<style lang="scss">
// Slick can't be scoped because of slider styles
@import "~slick-carousel/slick/slick.css";

.slick-slide .product-card {
  max-width: 192px;
}
</style>
